import {CpaModel} from './cpa.model';
import {EnrichmentModel} from './enrichment.model';
import {BaseModel} from '../../base/models/base-model.model';

export class PropertyModel extends BaseModel {
  private _admittedValues?: Array<string>;
  private _cpa?: Array<CpaModel>;
  private _description?: string;
  private _enrichment?: EnrichmentModel;
  private _mandatory?: boolean;
  private _name?: string;
  private _usable?: boolean;
  private _valorization?: boolean;
  private _value?: string;

  constructor(admittedValues?: Array<string>, cpa?: Array<CpaModel>, description?: string, enrichment?: EnrichmentModel, mandatory?: boolean, name?: string, usable?: boolean, valorization?: boolean, value?: string) {
    super();
    this._admittedValues = admittedValues;
    this._cpa = cpa;
    this._description = description;
    this._enrichment = enrichment;
    this._mandatory = mandatory;
    this._name = name;
    this._usable = usable;
    this._valorization = valorization;
    this._value = value;
  }

  get admittedValues(): Array<string> {
    return this._admittedValues;
  }

  set admittedValues(value: Array<string>) {
    this._admittedValues = value;
  }

  get mandatory(): boolean {
    return this._mandatory;
  }

  set mandatory(value: boolean) {
    this._mandatory = value;
  }

  get cpa(): Array<CpaModel> {
    return this._cpa;
  }

  set cpa(value: Array<CpaModel>) {
    this._cpa = value;
  }

  get description(): string {
    return this._description;
  }

  set description(value: string) {
    this._description = value;
  }

  get enrichment(): EnrichmentModel {
    return this._enrichment;
  }

  set enrichment(value: EnrichmentModel) {
    this._enrichment = value;
  }

  get name(): string {
    return this._name;
  }

  set name(value: string) {
    this._name = value;
  }

  get usable(): boolean {
    return this._usable;
  }

  set usable(value: boolean) {
    this._usable = value;
  }

  get valorization(): boolean {
    return this._valorization;
  }

  set valorization(value: boolean) {
    this._valorization = value;
  }

  get value(): string {
    return this._value;
  }

  set value(value: string) {
    this._value = value;
  }
}
